import React, { useContext, useState } from 'react';
import { ButtonBase, Menu, MenuItem, Typography } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { StateContext } from '../context/StateProvider';
import Utils from '../../utils/Utils';
import { LOCALSTORAGEKEYS } from '../../config/constants';

/**
 * Selector de ejercicio (año) del header como píldora compacta con menú.
 * En móvil colapsa a solo el año. Si el ejercicio no es el actual, la píldora
 * se tiñe de ámbar para avisar de que se están viendo datos históricos.
 */
export default function HeaderEjercicio({ compacto = false }) {
    const { state, updateState } = useContext(StateContext);
    const [anchorEl, setAnchorEl] = useState(null);

    const anioActual = Utils.getCurrentYear();
    const esHistorico = state.year !== anioActual;
    // DECISION: usar el año real como value (getArrayYears da '' para el año
    // actual, que rompía state.year con NaN al re-seleccionarlo)
    const anios = Utils.getArrayYears().map((opcion) => Number(opcion.label));

    const seleccionarAnio = (year) => {
        updateState({ year });
        localStorage.setItem(LOCALSTORAGEKEYS.EJERCICIO, year);
        setAnchorEl(null);
    };

    return (
        <>
            <ButtonBase
                id="header-year"
                onClick={(e) => setAnchorEl(e.currentTarget)}
                title={esHistorico ? `Ejercicio ${state.year} (histórico)` : `Ejercicio ${state.year}`}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.75,
                    height: compacto ? 26 : 34,
                    px: compacto ? 1 : { xs: 1.25, sm: 1.5 },
                    borderRadius: 99,
                    border: '1px solid',
                    borderColor: esHistorico ? '#ffc107' : '#e9ecef',
                    backgroundColor: esHistorico ? '#fff3cd' : '#f8f9fa',
                    color: esHistorico ? '#664d03' : '#495057',
                    transition: 'background-color 0.2s, border-color 0.2s',
                    '&:hover': {
                        backgroundColor: esHistorico ? '#ffe69c' : '#fff',
                        borderColor: esHistorico ? '#e0a800' : '#ced4da',
                    },
                }}
            >
                <CalendarMonthIcon sx={{ fontSize: 18, display: compacto ? 'none' : { xs: 'none', sm: 'block' } }} />
                <Typography sx={{ fontSize: compacto ? 12 : 14, fontWeight: 700, lineHeight: 1 }}>
                    {state.year}
                </Typography>
                <ExpandMoreIcon
                    sx={{
                        fontSize: 16,
                        display: compacto ? 'none' : { xs: 'none', sm: 'block' },
                        transition: 'transform 0.2s',
                        transform: anchorEl ? 'rotate(180deg)' : 'none',
                    }}
                />
            </ButtonBase>

            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                PaperProps={{
                    sx: {
                        borderRadius: 2,
                        boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
                        minWidth: 170,
                        mt: 0.5,
                    },
                }}
            >
                <Typography
                    sx={{
                        px: 2,
                        pt: 1,
                        pb: 0.5,
                        fontSize: 11,
                        fontWeight: 600,
                        color: '#6c757d',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                    }}
                >
                    Ejercicio
                </Typography>
                {anios.map((anio) => (
                    <MenuItem
                        key={anio}
                        selected={anio === state.year}
                        onClick={() => seleccionarAnio(anio)}
                        sx={{
                            fontSize: 14,
                            fontWeight: anio === state.year ? 700 : 400,
                            color: anio === state.year ? '#cc071e' : '#212529',
                            display: 'flex',
                            justifyContent: 'space-between',
                            gap: 2,
                            '&.Mui-selected': {
                                backgroundColor: '#fee',
                                '&:hover': { backgroundColor: '#fdd' },
                            },
                        }}
                    >
                        {anio}
                        {anio === anioActual && (
                            <Typography component="span" sx={{ fontSize: 11, color: '#6c757d' }}>
                                actual
                            </Typography>
                        )}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
}
